import React, { useEffect, useState } from 'react';
import ReactExport from "react-data-export";
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import { fileExcel } from 'react-icons-kit/icomoon/fileExcel'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import FrameF2 from '../components/FrameF2'


import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrTextInput from '../components/FrTextInput'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'
import FrSelect from '../components/FrSelect'

import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function Tabela_Precos() {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [comboMdc, setComboMdc] = useState([{ value: '', display: '' }])
  const [comboMat, setComboMat] = useState([{ value: '', display: '' }])

  const [mdc, setMdc] = useState([''])
  const [mat, setMat] = useState([''])

  const columns = [
    { id: 'descricao', numeric: false, label: 'Material / Medicamento', align: 'left', minWidth: 300 },
    { id: 'nomeuni', numeric: false, label: 'Unidade', align: 'left', minWidth: 150 },
  ]

  useEffect(() => {
    const fetchData = async () => {
      let tela = 'Tabela de Preços'
      let consulta = await api.getAcessos(tela, 'Consulta')

      if (consulta !== 'S') {
        swal.fire('Usuário sem acesso', 'Usuário sem acesso a essa tela!', 'warning')
          .then((result) => {
            if (result.value) {
              window.history.back()
            }
          })
      } else {

        swal.fire({
          html: <FrLoading text="Carregando..." />,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        })

        setenableAdd(await api.getAcessos(tela, 'Inclusao'))
        setenableEdit(await api.getAcessos(tela, 'Alteracao'))
        setComboMdc(await api.getComboData('medicamentos'))
        setComboMat(await api.getComboData('materiais'))

        const urlParams = new URLSearchParams(window.location.search);
        let query = paramsToObject(urlParams)
        setFilter(query)
        populateForm(document.getElementById('searchForm'), query)

        swal.close()
        if (query.buscar === 'true') {
          let event = new Event('build');
          getData(event)
        }
      }

    }
    fetchData()
  }, [])

  useEffect(() => {
    const fetchMdc = async () => {

      const auxValues = { ...filter };

      if (mdc > 0) {
        auxValues['fk_mdc'] = mdc;
        console.log(auxValues)
        setFilter(auxValues);
        
      }
    }
    fetchMdc()
  }, [mdc])

  useEffect(() => {
    const fetchMat= async () => {

      const auxValues = { ...filter };

      if (mat > 0) {
        auxValues['fk_mat'] = mat;
        console.log(auxValues)
        setFilter(auxValues);
      }
    }
    fetchMat()
  }, [mat])

  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    if (true) {
      queryObject.buscar = true
      setFiltered(true)
      window.history.replaceState({ filtered: true }, 'filter', "/primavera/tabela_precos?" + objectToQueryString(queryObject));
      swal.fire({
        html: <FrLoading text="Buscando dados..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      api.get('/tabela_precos?' + objectToQueryString(queryObject)).then(r => {

        setData(r.data)
        swal.close()
      })
    } else {
      swal.fire('Nenhum filtro informado!', 'Informe ao menos um filtro para realizar a busca.', 'warning')
    }
  }

  function clearForm(e) {
    e.preventDefault();
    console.log('limpa');
    window.history.replaceState({ filtered: false }, 'filter', '/primavera/tabela_precos');
    document.getElementById('searchForm').reset()
    setFilter({})
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    auxValues[e.target.name] = e.target.value;
    if(e.target.value =='') auxValues[e.target.name] = null
    console.log(auxValues)
    setFilter(auxValues);
  };

  return (

    <div className="Manut">
      <NavBar />
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Tabela de Preços</h3>
          <UserOptions app={'Tabela de Preços'} />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <FrSelect
                value={filter.fk_mdc || ''}
                style={{ width: 300 }}
                name="fk_mdc"
                id="fk_mdc"
                label='Medicamento'
                data={comboMdc}
                onChange={handleChange}
              />
              <FrameF2 tipoModal={'Medicamento'} data={data} mdc={mdc} setMdc={setMdc} ></FrameF2>              

              <FrSelect
                value={filter.fk_mat || ''}
                style={{ width: 300 }}
                name="fk_mat"
                id="fk_mat"
                label='Material'
                data={comboMat}
                onChange={handleChange}
              />
              <FrameF2 tipoModal={'Material'} data={data} mat={mat} setMat={setMat}></FrameF2>
              

            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              {enableAdd !== 'S' ? '' :
                <Link to="/primavera/tabela_precos/registro">
                  <button >
                    <Icon icon={ic_add_box} size={18} />
                    Novo Registro
                  </button>
                </Link>}

            </div>
          </form>
        </div>
        <br />
        <div className="tableDiv">
          <FrTable detail={true} regName="tabela_precos" columns={columns} searched={filtered} codeName="pk_tab" page={'tabela_precos'} data={data} enableEdit={enableEdit} enableDel={enableDel} />
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}


export default Tabela_Precos;
